import { render, staticRenderFns } from "./administratorsList.vue?vue&type=template&id=b8f0bf38&"
import script from "./administratorsList.vue?vue&type=script&lang=js&"
export * from "./administratorsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports